import React, {useMemo} from 'react';

import {useCurrentUserSocialAuth} from 'app/current-user/api';
import {useAccountSettingsState} from 'app/settings/api';
import {SOCIAL_AUTH_BEGIN_URL, SOCIAL_AUTH_DISCONNECT_URL} from 'app/urls';
import {gt} from 'app/utils/i18n';
import {getCSRFToken} from 'app/utils/urls';

export function SocialAuth() {
  const {isGoogleConnected, socialAccountName, isError} =
    useCurrentUserSocialAuth(undefined, {
      selectFromResult: (result) => ({
        isError: result.isError,
        isGoogleConnected: result.data?.some(
          (backend) => backend.provider === 'google-oauth2'
        ),
        socialAccountName: result.data?.find(
          (backend) => backend.provider === 'google-oauth2'
        )?.account_name,
      }),
    });
  const {STATIC_URL} = useAccountSettingsState().data!;
  const csrfToken = useMemo(getCSRFToken, []);

  if (isError)
    return (
      <p className="text-danger">
        {gt('Error loading social media accounts.')}
      </p>
    );

  return (
    <div className="pt-4">
      <h4 className="section pb-2 border-bottom">
        {gt('Social Media Accounts')}
      </h4>
      <p>
        {gt(
          'Connect your social media accounts to use them next time you sign into your account.'
        )}
      </p>

      <ul className="list-unstyled">
        <li className="pt-2">
          {isGoogleConnected ? (
            <div className="connected">
              <strong>{gt('Google Connected')}:</strong>
              <form
                method="POST"
                action={`${SOCIAL_AUTH_DISCONNECT_URL}google-oauth2/`}
              >
                <input
                  type="hidden"
                  name="csrfmiddlewaretoken"
                  value={csrfToken}
                />
                <button className="btn btn-link disabled pl-0" type="button">
                  {socialAccountName ?? gt('Google Account')}
                </button>
                <button className="btn btn-link" type="submit">
                  <i className="fa fa-times"></i> {gt('Disconnect')}
                </button>
              </form>
            </div>
          ) : (
            <a
              href={`${SOCIAL_AUTH_BEGIN_URL}google-oauth2/`}
              className="connect-social"
            >
              <img
                src={`${STATIC_URL}images/connect-google.png`}
                alt="Connect Google"
              />
            </a>
          )}
        </li>
      </ul>
    </div>
  );
}
